<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('system.group.groupName')" prop="type">
                <ic-select :options="groupTypes" v-model="queryCondition.type"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('sys.userList.userName')" prop="userName">
                <el-input v-model="queryCondition.userName" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="queryData(1)">{{ $t("common.search") }}</el-button>
            <el-button type="primary" @click="restQueryForm('queryCondition')">{{ $t("common.reset") }}</el-button>
          </el-row>
        </el-form>
        <div class="toolsBox">
          <el-button type="primary" @click="addCategory">{{ $t('common.addNew') }}</el-button>
          <el-button type="primary" @click="onDel">{{ $t('common.del') }}</el-button>
        </div>
        <el-table sortable :data="tableData" ref="tableList" border row-key="tmGroupId" highlight-current-row class="table">
          <el-table-column type="selection" fixed min-width="50" :reserve-selection="true"></el-table-column>
          <el-table-column show-overflow-tooltip prop="type" :label="$t('system.group.groupName')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="categoryCode" :label="$t('system.group.category')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="userName" label="用户名"></el-table-column>
          <el-table-column show-overflow-tooltip prop="hgsApproval" label="是否需HGS审批"></el-table-column>
          <el-table-column show-overflow-tooltip prop="supUserName" label="供应商用户"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="showDetailDialog(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('nav.categoryGroupAdd')" :visible.sync="categoryDetailDialog" width="30%" @close="categoryDetailDialogClose">
      <el-form v-if="categoryDetailDialog" :model="categoryDetailForm" ref="categoryDetailForm" class="categoryDetailForm" :rules="categoryDetailFormRules" label-width="120px">
        <el-row>
          <el-col :span="20">
            <el-form-item label="GroupCode" prop="type">
              <ic-select clearable :options="groupTypes" v-model="categoryDetailForm.type" @change="typeChange" :disabled="isDisabled"></ic-select>
            </el-form-item>
            <el-form-item :label="$t('system.group.category')" prop="tmCategoryId">
              <el-select v-model="categoryDetailForm.tmCategoryId" filterable :disabled="isDisabled">
                <el-option v-for="category in categoryList" :key="category.tmCategoryId" :value="category.tmCategoryId" :label="category.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('sys.userList.userName')" prop="userNames" class="is-required">
              <el-input v-model="categoryDetailForm.userNames" readonly>
                <el-button slot="append" icon="el-icon-search" @click="searchUser"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="是否需HGS审批" prop="hgsApproval" v-if="categoryDetailForm.type==='CQS'">
              <el-select v-model="categoryDetailForm.hgsApproval" clearable style="width:100%">
                <el-option :key="index" v-for="(item,index) in hgsApprovalLists" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商用户" prop="supUserName" label-width="120px" v-if="categoryDetailForm.type==='CQS'">
              <el-input v-model.trim="categoryDetailForm.supUserName" readonly style="width: 100%;">
                <el-button slot="append" icon="el-icon-search" @click="searchSupplier"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="closeDialog">{{ $t('common.close') }}</el-button>
        <!-- 新增 -->
        <el-button type="primary" @click="saveAdd" v-if="isAdd">{{ $t('common.save') }}</el-button>
        <!-- 修改 -->
        <el-button type="primary" @click="saveEdit" v-if="isEdit">{{ $t('common.save') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showUserDialog" append-to-body width="80%">
      <PickupUser v-if="DestroyUserDialog == true" @input="selectUser" :multi="true" :SelectedDefault="true" :emplFlag="'MCD'" :SelectedDefaultId="categoryDetailForm.leaders"></PickupUser>
    </el-dialog>
    <el-dialog :visible.sync="showSupplierDialog" append-to-body width="80%">
      <PickupSupplier @closeSelSupplier="closeSelSupplier" :supplierIds="this.supplierIds" ref="PickupSupplier"></PickupSupplier>
    </el-dialog>
  </div>
</template>

<script>
import commonFunction from "@/utils/dataTableUtils";
import group from "@/api/system/group";
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import PickupUser from "@/components/page/sensory/sensory-template/choiceUser";
import PickupSupplier from "./selSupplierCode.vue";
import { categoryLeaderApi } from "@/api/system/categoryLeader";
import { apiService as materialApi } from "@/api/material/material-master-data";

export default {
  name: "categoryGroupList",
  components: { IcSelect, PickupUser, PickupSupplier },
  extends: commonFunction,
  computed: {
    category() {
      return code => {
        if (commonFun.isNotEmpty(code)) {
          return commonFun.getICVal("BASE", code.substr(0, 2), code);
        }
        return "";
      };
    }
  },
  created() {
    categoryLeaderApi.findCategory({ categoryLevel: 2 }).then(res => {
      this.categoryList = res.data;
    })
    this.queryData();
  },
  data() {
    return {
      categoryList: [],
      DestroyUserDialog: "",
      categoryDetailDialog: false,
      showSupplierDialog: false,
      showUserDialog: false,
      isDisabled: false,
      categoryDetailForm: {
        userNames: "",
        leaderIds: [],
        groupCode: "",
        tmCategoryId: "",
        categoryCode: "",
        hgsApproval: "",
        suppliers: [],
        supUserName: "",
        supplierIds: [],
        type: "",
      },
      hgsApprovalLists: [
        {
          label: "Y",
          value: "Y"
        },
        {
          label: "N",
          value: "N"
        }
      ],
      groupTypes: { ADMIN: 'ADMIN', CQS: 'CQS', SS: 'SS', NFC: 'NFC', MDM: 'MDM',QSPI_SS:"QSPI_SS",SCFINANCE:"SC-FINANCE"},
      categoryDetailFormRules: {
        groupName: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: "change" }
        ],
        groupCode: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: "change" }
        ],
        categoryCode: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: "change" }
        ],
        // tmCategoryId: [
        //   { validator: checkTmCategoryId, trigger: "change" }
        // ],
        userNames: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: "change" }
        ]
      },
      queryCondition: {
        groupName: "",
        category: "",
        type: null,
        userName: "",
        pageNum: 1,
        pageSize: 10,
      },
      totalCount: null,
      tableData: [],
      defaultUser: [],
      supplierIds: [],
      isAdd: false,
      isEdit: false,
    };
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      categoryLeaderApi.query(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    restQueryForm() {
      this.queryCondition = {
        groupName: "",
        category: "",
        type: null,
        userName: "",
        pageNum: 1,
        pageSize: 10,
      }
      this.queryData()
    },
    addCategory() {
      this.categoryDetailForm.groupName = "";
      this.categoryDetailForm.userNames = "";
      this.categoryDetailForm.tmGroupId = "";
      this.categoryDetailForm.leaderIds = [];
      this.categoryDetailForm.leaders = [];
      this.categoryDetailForm.groupCode = "";
      this.categoryDetailForm.categoryCode = "";
      this.categoryDetailForm.tmCategoryId = null;
      this.isAdd = true
      this.isEdit = false
      this.categoryDetailDialog = true;
      this.isDisabled = false
    },
    showDetailDialog(row) {
      this.isDisabled = true
      this.isAdd = false
      this.isEdit = true
      categoryLeaderApi.getDetail(row).then(res => {
        console.log("🚀 ~ file: materialCategoryLeaderList.vue ~ line 226 ~ categoryLeaderApi.getDetail ~ res", res)
        this.categoryDetailForm = res.data;
        let leaders = res.data.leaders;
        this.defaultUser = leaders;
        if (res.data.leaders && res.data.leaders.length > 0) {
          this.categoryDetailForm.userNames = res.data.leaders.map(leader => leader.name).join(",");
          this.categoryDetailForm.leaderIds = res.data.leaders.map(leader => leader.tmUserId);
        }
        if (res.data.suppliers && res.data.suppliers.length > 0) {
          this.categoryDetailForm.suppliers = res.data.suppliers;
          this.categoryDetailForm.supplierIds = res.data.suppliers.map(ele => ele.tmUserId);
          this.categoryDetailForm.supUserName = res.data.suppliers.map(ele => ele.name).join(",");
        }
      })
      this.categoryDetailDialog = true;
      console.log('this.categoryDetailForm', this.categoryDetailForm);
    },
    onDel() {
      let rows = this.$refs.tableList.selection;
      console.log('rows', rows);
      var arr = []
      if (rows.length == 0) {
        this.$message({
          message: this.$t("common.pleaseSelectData"),
          type: "warning"
        });
      } else {
        rows.forEach(ele => {
          arr.push({
            type: ele.type,
            tmCategoryId: ele.tmCategoryId,
          })
        })
        // 请确认是否删除!
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          // customClass:'colorBtn',
          type: 'warning'
        }).then(() => {
          console.log(arr)
          group.onDel(arr).then(res => {
            if (res.code == 200) {
              this.$message({
                message: this.$t("common.delSuccess"),
                type: "success"
              });
              this.queryData(1);
              this.$refs.tableList.clearSelection()
            }
          });
        }).catch(() => {

        });

      }
    },
    saveEdit() {
      let that = this;
      this.$refs['categoryDetailForm'].validate(valid => {
        if (valid) {
          if (!this.categoryDetailForm.userNames || !this.categoryDetailForm.leaderIds) {
            this.$message.error('请选择用户名')
            return false
          }
          this.DestroyUserDialog = false;
          categoryLeaderApi.save(this.categoryDetailForm).then(res => {
            console.log(res)
            if (res.code == 200) {
              that.$message({
                message: this.$t("common.saveSuccess"),
                type: "success"
              });
              that.queryData();
              this.categoryDetailDialog = false;
              this.DestroyUserDialog = false;
              this.categoryDetailForm = {
                userNames: "",
                leaderIds: [],
                groupCode: "",
                tmCategoryId: "",
                categoryCode: "",
                hgsApproval: "",
                suppliers: null,
                supUserName: "",
                supplierIds: [],
              }
            }
          })
        }
      });
    },
    saveAdd() {
      let that = this;
      this.$refs['categoryDetailForm'].validate(valid => {
        if (valid) {
          // if (!this.categoryDetailForm.userNames || !this.categoryDetailForm.leaderIds) {
          //   this.$message.error('请选择用户名')
          //   return false
          // }
          this.DestroyUserDialog = false;
          categoryLeaderApi.saveAdd(this.categoryDetailForm).then(res => {
            console.log(res)
            if (res.code == 200) {
              that.$message({
                message: this.$t("common.saveSuccess"),
                type: "success"
              });
              that.queryData();
              this.categoryDetailDialog = false;
              this.DestroyUserDialog = false;
              this.categoryDetailForm = {
                userNames: "",
                leaderIds: [],
                groupCode: "",
                tmCategoryId: "",
                categoryCode: "",
                hgsApproval: "",
                suppliers: null,
                supUserName: "",
                supplierIds: [],
              }
            }
          })
        }
      });
    },
    typeChange(e) {
      if (e !== 'CQS') {
        this.categoryDetailForm.suppliers = []
        this.categoryDetailForm.supplierIds = []
        this.categoryDetailForm.supUserName = ''
      }
    },
    closeDialog() {
      this.categoryDetailDialog = false;
      this.DestroyUserDialog = false
      this.$refs.PickupSupplier.$refs.pickUserTable.clearSelection();
      this.categoryDetailForm = {
        userNames: "",
        leaderIds: [],
        groupCode: "",
        tmCategoryId: "",
        categoryCode: "",
        hgsApproval: "",
        suppliers: [],
        supUserName: "",
        supplierIds: [],
        leaders: [],
      }
    },
    searchUser(val) {
      this.DestroyUserDialog = false;
      this.$nextTick(() => {
        this.DestroyUserDialog = true;
      });
      this.showUserDialog = true;
    },
    searchSupplier() {
      this.showSupplierDialog = true;
      console.log('suppliers', this.categoryDetailForm.supplierIds);
      this.supplierIds = this.categoryDetailForm.supplierIds
    },
    closeSelSupplier() {
      this.showSupplierDialog = false;
      var suppierArr = JSON.parse(sessionStorage.getItem('selectSupplier'))
      console.log('suppierArr', suppierArr);
      console.log('suppliers', this.categoryDetailForm.suppliers);
      this.categoryDetailForm.supplierIds = suppierArr.map(ele => ele.tmUserId);
      this.categoryDetailForm.supUserName = suppierArr.map(ele => ele.name).join(",");
      suppierArr.forEach(ele => {
        this.categoryDetailForm.suppliers.push(ele)
      })
    },
    selectUser(list) {
      console.log("🚀 ~ file: materialCategoryLeaderList.vue ~ line 404 ~ selectUser ~ list", list)
      let that = this;
      if (list.length > 0) {
        that.categoryDetailForm.leaders = [];
        that.categoryDetailForm.leaderIds = [];
        list.forEach(item => {
          that.categoryDetailForm.leaders.push(item);
          that.categoryDetailForm.leaderIds.push(item.tmUserId);
        });
        that.categoryDetailForm.userNames = list.map(data => data.username).join(",");
      } else {
        this.categoryDetailForm.leaderIds = [];
        this.categoryDetailForm.userNames = "";
        this.categoryDetailForm.userName = "";
        this.categoryDetailForm.leaders = [];
        this.$forceUpdate();
      }
      that.DestroyUserDialog = false; //为了重新渲染子组件
      that.showUserDialog = false;
    },
    categoryDetailDialogClose() {
      console.log('categoryDetailForm', this.categoryDetailForm);
      console.log('supplierIds', this.categoryDetailForm.supplierIds);
      console.log('supUserName', this.categoryDetailForm.supUserName);
      console.log('suppliers', this.categoryDetailForm.suppliers);
      console.log('PickupSupplier', this.$refs.PickupSupplier);
      this.closeDialog()
    }
  }
};
</script>

<style scoped lang="scss">
.table {
  margin-top: 10px;
}

.categoryDetailForm {
  .el-input {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }
}
</style>
